import { useQuery } from "@tanstack/react-query";
import { multipliersQueryOptions } from "@/api/multipliers";
import { Loader } from "@/components/general/common/loader";
import { KpiMethodologyLayout } from "@/components/general/Kpis/KpiMethodologyLayout";

const LoadingState = () => (
    <div className="flex-1 flex items-center justify-center min-h-0 h-[640px] bg-surface-container-lowest rounded-xl shadow-sm p-6">
        <Loader message="Loading KPI methodology data..." />
    </div>
);

const ErrorState = () => (
    <div className="flex-1 flex items-center justify-center min-h-0 h-[640px] bg-surface-container-lowest rounded-xl shadow-sm p-6">
        <p className="text-on-surface-variant">Failed to load KPI methodology data</p>
    </div>
);

export const KpisCurrentPage = () => {
    const { data, isLoading, error } = useQuery(multipliersQueryOptions());
    return (
        <>
            {isLoading && <LoadingState />}
            {error && <ErrorState />}
            {data && (
                <div id="onboarding-kpis-current" className="space-y-4">
                    <div
                        id="onboarding-kpis-current-info"
                        className="bg-surface-container-lowest rounded-xl shadow-sm px-6 py-4"
                        style={{ borderLeft: "4px solid #050066" }}
                    >
                        <p className="text-sm font-semibold text-primary mb-1">Current KPI Configuration</p>
                        <p className="text-sm text-on-surface-variant">
                            This view shows how the KPI system looks like currently. If the scoring does not reflect the
                            state shown below, you may need to recalculate the database, which can be done by clicking
                            the button in the application settings.
                        </p>
                    </div>
                    <div id="onboarding-kpis-methodology">
                        <KpiMethodologyLayout data={data} />
                    </div>
                </div>
            )}
        </>
    );
};
